import { FC } from "react";
import { FaCow } from "react-icons/fa6";
import { HiBeaker, HiBolt, HiBuildingLibrary, HiBuildingOffice2, HiMegaphone, HiTrash, HiTruck } from "react-icons/hi2";

import { IconCalendarSolid } from "@/components/_icons/IconCalendarSolid";
import { IconChartPie } from "@/components/_icons/IconChartPie";
import { IconCheckCircleFilled } from "@/components/_icons/IconCheckCircleFilled";
import { IconCheckLine } from "@/components/_icons/IconCheckLine";
import { IconCircleCanceled } from "@/components/_icons/IconCircleCanceled";
import { IconCircleChecked } from "@/components/_icons/IconCircleChecked";
import { IconCircleDashed } from "@/components/_icons/IconCircleDashed";
import { IconCircleFilledHalf } from "@/components/_icons/IconCircleFilledHalf";
import { IconCircleOutline } from "@/components/_icons/IconCircleOutline";
import { IconClipboardMinus } from "@/components/_icons/IconClipboardMinus";
import { IconDashesHorizontal } from "@/components/_icons/IconDashesHorizontal";
import { IconFlag } from "@/components/_icons/IconFlag";
import IconHeartbeatCircle from "@/components/_icons/IconHeartbeatCircle";
import { IconPriorityHigh } from "@/components/_icons/IconPriorityHigh";
import { IconPriorityLow } from "@/components/_icons/IconPriorityLow";
import { IconPriorityMedium } from "@/components/_icons/IconPriorityMedium";
import { IconPriorityUrgent } from "@/components/_icons/IconPriorityUrgent";
import IconRocket from "@/components/_icons/IconRocket";
import { IconSquareCheck } from "@/components/_icons/IconSquareCheck";
import { IconTargetHit } from "@/components/_icons/IconTargetHit";

import { IconTypes } from "./icon.schema";

export const iconMap: Record<string, FC<{ className?: string; style?: React.CSSProperties; "aria-hidden"?: boolean | "true" | "false" }>> = {
  "circle-dashed": IconCircleDashed,
  "circle-outline": IconCircleOutline,
  "circle-filled-half": IconCircleFilledHalf,
  "circle-checked": IconCircleChecked,
  "circle-canceled": IconCircleCanceled,
  "phase-rocket": IconRocket,
  "phase-target-hit": IconTargetHit,
  "phase-check-circle": IconCheckCircleFilled,
  "phase-check-line": IconCheckLine,
  "phase-calendar": IconCalendarSolid,
  "phase-clipboard": IconClipboardMinus,
  "phase-chart-pie": IconChartPie,
  "phase-flag": IconFlag,
  "phase-square-check": IconSquareCheck,
  "phase-heartbeat-circle": IconHeartbeatCircle,
  "priority-low": IconPriorityLow,
  "priority-medium": IconPriorityMedium,
  "priority-high": IconPriorityHigh,
  "priority-urgent": IconPriorityUrgent,
  "bolt": HiBolt,
  "building-office": HiBuildingOffice2,
  "truck": HiTruck,
  "beaker": HiBeaker,
  "trash": HiTrash,
  "cow": FaCow,
  "building-library": HiBuildingLibrary,
  "megaphone": HiMegaphone,
};

export interface IconViewProps {
  icon?: string | null;
  iconType?: string | null;
  color?: string;
  className?: string;
}

export const IconView: FC<IconViewProps> = ({ icon, iconType, color, className }) => {
  if (iconType === IconTypes.emoji && icon) {
    return <span className={className} aria-hidden="true">{icon}</span>;
  }

  if (icon && icon in iconMap) {
    const IconComponent = iconMap[icon];
    return <IconComponent className={className} style={color ? { color } : undefined} aria-hidden="true" />;
  }

  return <IconDashesHorizontal className={className} aria-hidden="true" />;
};
